import React, {useState} from 'react';
import {connect} from "react-redux";
import {useForm} from "react-hook-form";
import Switch from "react-bootstrap-switch";
import { CardBody, Col, Form, FormGroup, Input, Label, Row, } from 'reactstrap';

// components
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";

// labels
import { PH_CODE, } from "../../../components/i18n/placeHolders";
import {FL_CODE, FL_ONLY_REGISTERED, FL_STATUS} from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generalActions/listActions";

const RestrictionFilters = (props) => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const [status, setStatus] = useState(filter?.item?.status || null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const {register, handleSubmit, reset} = useForm({
    });

    const cleanFields = () => {
        setStatus(null);
        reset();
    }

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            onlyRegistered : onlyRegistered,
            item : {
                ...data
            }
        }

        if (status !== undefined && status !== null){
            dataFilter.item.status = status;
        }

        props.setFilter(dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_CODE }</Label>
                            <Input type="text"
                                   name="code"
                                   placeholder={ PH_CODE }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ FL_STATUS }</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_ONLY_REGISTERED }</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(RestrictionFilters)